export default __webpack_public_path__ + "static/media/adminImg.a78a2292.png";